module.exports = __webpack_public_path__ + "img/stage-2-motion.62d5c7fa.png";